// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"447a73e3","455":"89fe3bf7","977":"eb0f9b80"}[chunkId] + ".chunk.js";
};